import * as React from 'react';

interface PhotoTypeFallbackProps {
  src: string | { default: string, webp?: string },
  alt: string
}

export const PhotoTypeFallback = ({
    src,
    alt
}: PhotoTypeFallbackProps) => {
  return typeof src === 'string' ? (
    <img src={src} alt={alt} />
  ) : (
    <>
      <source srcSet={src.webp} type="image/webp" />
      <img src={src.default} alt={alt} />
    </>
  );
};
